"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _classnames = _interopRequireDefault(require("classnames"));

var _dateParser = require("../_utils/dateParser");

var _config = require("../config/config");

require("./timePicker.sass");

var _ref = _react.default.createElement("div", {
  className: "timePicker-delim"
}, ":");

var _ref2 = _react.default.createElement("div", {
  className: "timePicker-space"
});

var TimePicker =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TimePicker, _PureComponent);

  function TimePicker() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TimePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TimePicker)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "controlled", _this.props.hasOwnProperty('value'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      value: _this.controlled ? null : (0, _dateParser.parseTime)(_this.props.defaultValue)
    });
    return _this;
  }

  (0, _createClass2.default)(TimePicker, [{
    key: "getValue",
    value: function getValue() {
      if (this.controlled) {
        return (0, _dateParser.parseTime)(this.props.value);
      }

      return this.state.value;
    }
  }, {
    key: "isMeridiem",
    value: function isMeridiem() {
      if (this.props.hasOwnProperty('isMeridiem')) {
        return this.props.isMeridiem;
      }

      return (0, _moment.default)().localeData().longDateFormat('LT').indexOf('A') >= 0;
    }
  }, {
    key: "handleSet",
    value: function handleSet(val, unit) {
      var _this2 = this;

      return function (e) {
        var value = (0, _moment.default)({
          minutes: _this2.getValue().minutes(),
          hours: _this2.getValue().hours()
        }).set(unit, val);

        if (!_this2.controlled) {
          _this2.setState({
            value: value
          });
        }

        _this2.props.onChange && _this2.props.onChange(value);
      };
    }
  }, {
    key: "renderMinute",
    value: function renderMinute(minutes) {
      minutes = (minutes + 60) % 60;
      return _react.default.createElement("div", {
        className: "timePicker-val",
        onClick: this.handleSet(minutes, 'minutes'),
        key: minutes
      }, minutes);
    }
  }, {
    key: "renderMinutes",
    value: function renderMinutes() {
      var _this3 = this;

      var minutes = this.getValue().minutes();
      var step = this.props.step;
      return _react.default.createElement("div", {
        className: "timePicker-section"
      }, _react.default.createElement("div", {
        className: "timePicker-vals timePicker-vals--prev"
      }, [3 + step, 2 + step, 1].map(function (i) {
        return _this3.renderMinute(minutes - i);
      })), minutes, _react.default.createElement("div", {
        className: "timePicker-vals timePicker-vals--next"
      }, [1, 2 + step, 3 + step].map(function (i) {
        return _this3.renderMinute(minutes + i);
      })));
    }
  }, {
    key: "renderHour",
    value: function renderHour(hours, isMeridiem) {
      // normalize to 0 - 24
      hours = (hours + 24) % 24;

      if (isMeridiem) {
        var pm = this.getValue().hours() >= 12 ? 12 : 0;
        hours = hours % 12 + pm;
      }

      return _react.default.createElement("div", {
        className: "timePicker-val",
        onClick: this.handleSet(hours, 'hours'),
        key: hours
      }, isMeridiem ? 1 + (hours + 11) % 12 : hours);
    }
  }, {
    key: "renderHours",
    value: function renderHours() {
      var _this4 = this;

      var step = this.props.step;
      var isMeridiem = this.isMeridiem();
      var hours = this.getValue().hours();
      return _react.default.createElement("div", {
        className: "timePicker-section"
      }, _react.default.createElement("div", {
        className: "timePicker-vals timePicker-vals--prev"
      }, [3 + step, 2 + step, 1].map(function (i) {
        return _this4.renderHour(hours - i, isMeridiem);
      })), isMeridiem ? 1 + (hours + 11) % 12 : hours, _react.default.createElement("div", {
        className: "timePicker-vals timePicker-vals--next"
      }, [1, 2 + step, 3 + step].map(function (i) {
        return _this4.renderHour(hours + i, isMeridiem);
      })));
    }
  }, {
    key: "renderMeridiem",
    value: function renderMeridiem() {
      if (!this.isMeridiem()) {
        return null;
      }

      var hours = this.getValue().hours();
      var pm = hours >= 12;

      if (pm) {
        return _react.default.createElement("div", {
          className: "timePicker-section"
        }, _react.default.createElement("div", {
          className: "timePicker-vals timePicker-vals--prev"
        }, _react.default.createElement("div", {
          className: "timePicker-val",
          onClick: this.handleSet(hours - 12, 'hours')
        }, (0, _config.__)('AM'))), (0, _config.__)('PM'));
      }

      return _react.default.createElement("div", {
        className: "timePicker-section"
      }, (0, _config.__)('AM'), _react.default.createElement("div", {
        className: "timePicker-vals timePicker-vals--next"
      }, _react.default.createElement("div", {
        className: "timePicker-val",
        onClick: this.handleSet(hours + 12, 'hours')
      }, (0, _config.__)('PM'))));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('timePicker', this.props.className)
      }, _react.default.createElement("div", {
        className: "timePicker-content"
      }, this.renderHours(), _ref, this.renderMinutes(), _ref2, this.renderMeridiem()));
    }
  }]);
  return TimePicker;
}(_react.PureComponent);

exports.default = TimePicker;
(0, _defineProperty2.default)(TimePicker, "defaultProps", {
  step: 0
});
TimePicker.propTypes = process.env.NODE_ENV !== "production" ? {
  onChange: _propTypes.default.func,
  onKeyUp: _propTypes.default.func,
  isMeridiem: _propTypes.default.bool,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]),
  step: _propTypes.default.number
} : {};